function useLinkProps({ href, target = '_self', title = '' }) {
  return {
    href,
    target,
    title
  }
}

export default useLinkProps
